import Router, { useRouter } from 'next/router';
import { useEffect } from 'react';
const langs = require('../../scripts/configs/langs.json');
import axios from 'axios';
import { API_SERVER_URL, SITE_URL, logOutFunction } from './utils';
import { zendoStorage } from '../../hybrid/wrappers';
import { checkIsPartner } from './memo';

export const getLang = (url) => {
    return langs.find((lang) => url === `/${lang}` || url?.startsWith(`/${lang}/`)) || '';
};
export const getRoute = (url, confirmPresence) => {
    const removeGetParams = confirmPresence ? url : url.split('?')[0];
    const lang = getLang(removeGetParams);
    if (!lang) {
        if (!removeGetParams) {
            return '/';
        }
        if (removeGetParams.startsWith('/default/') || removeGetParams === '/default') {
            return removeGetParams === '/default' ? '/' : removeGetParams.replace('/default/', '/');
        }
        return removeGetParams;
    }
    return removeGetParams === `/${lang}` ? '/' : removeGetParams.replace(`/${lang}/`, '/');
};

export const navigateV2 = (url, replace) => {
    const lang = getLang(Router.router.asPath);
    const redirectUrl = `${lang ? `/${lang}` : ''}${url}`;
    if (redirectUrl === Router.router.asPath) {
        return Router.router.reload();
    }
    if (replace) {
        Router.router.replace(redirectUrl);
    } else {
        Router.router.push(redirectUrl);
    }
};
export const replaceUrl = (url, router, isRelative) => {
    const asPath = router?.asPath || Router?.router?.asPath;
    const lang = getLang(asPath);
    return `${!isRelative ? SITE_URL : ''}${lang ? `/${lang}` : ''}${url}`;
};
export const navigate = (url, asRout, lang, replace) => {
    if (replace) {
        if (asRout && lang?.length > 0) {
            Router.router.replace(url === '/' ? '/[lang]' : url, `/${lang}${asRout}`);
        } else if (asRout) {
            Router.router.replace(url.replace('/[lang]', ''), `${asRout}`);
        } else {
            Router.router.replace(url);
        }
    } else {
        if (asRout && lang?.length > 0) {
            Router.router.push(url === '/' ? '/[lang]' : url, `/${lang}${asRout}`);
        } else if (asRout) {
            Router.router.push(url.replace('/[lang]', ''), `${asRout}`);
        } else {
            Router.router.push(url);
        }
    }
};

export const useHistoryStore = (save, type, confirmPresence) => {
    const router = useRouter();
    useEffect(() => {
        if (save) {
            zendoStorage.set(
                'prevUrlData',
                JSON.stringify({
                    route: getRoute(router.asPath, confirmPresence),
                    type
                })
            );
        }
    }, [router, type, save]);
};

export const dataSender = (
    url,
    method,
    data,
    susseccFunc = () => {},
    errorFunc = () => {},
    userToken,
    lang,
    currency,
    dataType = 'json',
    imageAttrs = [],
    additionalHeaders = {}
) => {
    const headers = userToken
        ? {
              'X-Requested-With': 'XMLHttpRequest',
              ...(dataType !== 'hidden'
                  ? { 'Content-Type': `${dataType === 'json' ? 'application/json' : 'multipart/form-data'};charset=UTF-8` }
                  : {}),
              ...(userToken ? { Authorization: `Bearer ${userToken}` } : {}),
              mode: 'no-cors',
              ...(lang ? { 'Accept-Language': lang } : {}),
              ...(currency ? { 'Accept-Currency': currency } : {}),
              ...(additionalHeaders ? additionalHeaders : {})
          }
        : {
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': `${dataType === 'json' ? 'application/json' : 'multipart/form-data'};charset=UTF-8`,
              ...(lang ? { 'Accept-Language': lang } : {}),
              ...(currency ? { 'Accept-Currency': currency } : {})
          };
    let newUrl = url;

    const config = {
        method: !['POST', 'GET'].includes(method) && dataType !== 'json' ? 'POST' : method,
        url: newUrl,
        headers
    };

    if (data && dataType === 'json') {
        config.data = JSON.stringify(data);
    } else {
        let newData = new FormData();
        if (!data?.['_method']) {
            newData.append('_method', method);
        }
        for (let key in data) {
            if (key === 'image' || key === 'seo_image' || key === 'picture' || imageAttrs?.includes(key)) {
                if (data[key]?.url || data[key]?.links?.preview || data[key]?.links?.original) {
                    // newData.append(key, '');
                } else {
                    newData.append(key, data[key]);
                }
            } else if (key === 'moreImage' || key === 'videos' || key === 'files') {
                if (data[key].length > 0) {
                    data[key].map((img, idx) => {
                        if (img?.url || img?.links?.preview || img?.links?.original) {
                        } else {
                            newData.append(`${key}[${idx}]`, img);
                        }
                    });
                }
            } else if (key === 'related_products') {
                data[key]?.length
                    ? data[key].map((item, idx) => {
                          newData.append(`${key}[${idx}]`, item);
                      })
                    : newData.append(key, []);
            } else if (Array.isArray(data[key])) {
                //Проверка на массив
                data[key].map((item, idx) => {
                    if (typeof item === 'object') {
                        // Проверка на массив объектов
                        if (['categories', 'special_statuses', 'visibly_countries'].includes(key)) {
                            newData.append(`${key}[${idx}]`, item.id || item.value);
                        } else {
                            for (let k in item) {
                                if (Array.isArray(item[k])) {
                                    item[k].map((j, index) => {
                                        if (!isNaN(j)) {
                                            newData.append(`${key}[${idx}][${k}][${index}]`, j);
                                        } else {
                                            for (let m in j) {
                                                if (Array.isArray(j[m])) {
                                                    newData.append(`${key}[${idx}][${k}][${index}][${m}]`, j[m][0]);
                                                } else {
                                                    newData.append(`${key}[${idx}][${k}][${index}][${m}]`, j[m]);
                                                }
                                            }
                                        }
                                    });
                                } else {
                                    newData.append(`${key}[${idx}][${k}]`, item[k]);
                                }
                            }
                        }
                    } else {
                        // Массив чисел, строк и т.д.
                        newData.append(`${key}[${idx}]`, item);
                    }
                });
            } else if (typeof data[key] === 'object') {
                // Проверка на объект
                for (let k in data[key]) {
                    if (Array.isArray(data[key][k])) {
                        data[key][k].forEach((val, idx) => {
                            newData.append(`${key}[${k}][${idx}]`, val);
                        });
                    } else {
                        newData.append(`${key}[${k}]`, data[key][k]);
                    }
                }
            } else {
                newData.append(key, data[key]);
            }
        }
        config.data = newData;
    }

    axios(config)
        .then((response) => {
            if (response.status === 204) {
                susseccFunc({ status: 204 });
            } else {
                susseccFunc(response);
            }
        })
        .catch((error) => {
            if (!error.response) return false;
            const { data, status, headers } = error.response;

            if (status === 401) {
                logOutFunction();
            } else {
                if (status === 0) {
                    document.location.reload();
                } else if (status === 403 && data?.message?.toLowerCase() === 'unauthenticated' && data?.auth_route) {
                    zendoStorage.set('unauthenticated', JSON.stringify({ ...data, reloadPage: true }), true);
                } else {
                    errorFunc(data, status, headers);
                }
            }
        });
};

export const getData = async (
    url,
    userToken,
    lang,
    ip,
    currency,
    changeNeedReloadToken,
    returnData,
    contentType,
    additionalHeaders = {}
) => {
    if (!url) {
        return false;
    }

    let newUrl = url;
    const resultUrl = newUrl.includes('https://') || newUrl.includes('http://') ? newUrl : `${API_SERVER_URL}${newUrl}`;
    try {
        const res = await fetch(resultUrl, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                ...(contentType ? { 'Content-Type': contentType } : { 'Content-Type': 'application/json;charset=UTF-8' }),
                ...(userToken ? { Authorization: `Bearer ${userToken}` } : {}),
                ...(lang ? { 'Accept-Language': lang } : {}),
                ...(ip ? { ClientNodeIp: ip } : {}),
                ...(currency ? { 'Accept-Currency': currency } : {}),
                mode: 'no-cors',
                'Access-Control-Allow-Origin': '*',
                ...(additionalHeaders ? additionalHeaders : {})
            }
        });

        if (res.status === 500) {
            console.warn(url, res);
            return { status: 500 };
        }
        if (res.status === 404 || !res) {
            if (res && returnData) {
                return res;
            }
            return false;
        } else if (res.status === 403) {
            const checkForbidden = await res.json();
            changeNeedReloadToken && changeNeedReloadToken();
            if (checkForbidden?.auth_route && checkForbidden?.message?.toLowerCase() === 'unauthenticated') {
                zendoStorage.set('unauthenticated', JSON.stringify({ ...checkForbidden, reloadPage: true }), true);
            }
            if (returnData) {
                return checkForbidden;
            } else {
                return false;
            }
        } else if (res.status === 503) {
            navigateV2('/error/503');
            return false;
        } else if (res.status === 401) {
            await logOutFunction();
            return false;
        } else if (returnData) {
            return res;
        } else {
            return await res.json();
        }
    } catch (e) {
        console.warn(url, e);
        return false;
    }
};

export const htmlFormSend = (path, params) => {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = path;
    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = params[key];
            form.appendChild(hiddenField);
        }
    }
    document.body.appendChild(form);
    form.submit();
};

export const checkAccess = (setProfileData, userToken, lang, isLoaded = true, permission) =>
    new Promise((resolve, reject) => {
        if (!userToken) {
            navigateV2('/authentication/login');
            reject();
        }
        if (!isLoaded) {
            reject();
        }
        checkIsPartner(userToken, lang).then((data) => {
            if (data?.data?.data) {
                setProfileData(data?.data?.data);
                resolve(data?.data?.data);
            } else {
                if (data === 401) {
                    logOutFunction();
                    reject();
                } else if (data === 403 || data === 404) {
                    if (data !== 403 || !permission) {
                        navigateV2(`/error/${data || 500}`);
                        reject();
                    } else {
                        resolve();
                    }
                } else if (data === 503) {
                    navigateV2('/error/503');
                    reject();
                } else {
                    resolve();
                }
            }
        });
    });

export const revalidate = (filters = {}) => {
    const optimizedFilters = Object.keys(filters).reduce((acc, filter) => {
        return {
            ...acc,
            [filter]:
                typeof filters[filter] === 'string'
                    ? filters[filter]
                    : filters[filter].reduce((acc, item) => {
                          if (acc.includes(item)) {
                              return acc;
                          }
                          return [...acc, item];
                      }, [])
        };
    }, {});

    return new Promise((resolve) => {
        {
            dataSender(
                `${SITE_URL}/api/revalidate`,
                'POST',
                optimizedFilters,
                (data) => resolve(data.data),
                () => resolve()
            );
        }
    });
};
